export enum TachoType {
  CHART = 'CHART',
  TABLE = 'TABLE',
  VEHICLE_ECHART = 'VEHICLE_ECHART'
}
